import { render, staticRenderFns } from "./Dell.vue?vue&type=template&id=7ad0969c&scoped=true&"
import script from "./Dell.vue?vue&type=script&lang=js&"
export * from "./Dell.vue?vue&type=script&lang=js&"
import style0 from "./Dell.vue?vue&type=style&index=0&id=7ad0969c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad0969c",
  null
  
)

export default component.exports